import React, { Component } from "react";
import TournamentCardComponent from "../Tournaments/TournamentCardComponent";
import loadinggif from "../../assets/images/loading.gif";
import NotFoundContainer from "../../containers/NotFoundContainer";

class ChallengesLiveViewAllComponent extends Component {
  componentDidMount() {
    this.props.invalidateFriendsProfileDetails();
    this.props.fetchFriendsProfileIfNeeded({
      profileId: this.props.match.params.id
    });

    const {
      fetchFriendsTournamentsViewAllIfNeeded,
      invalidateAllFriendsTournamentsViewAll,
      page
    } = this.props;
    invalidateAllFriendsTournamentsViewAll();
    fetchFriendsTournamentsViewAllIfNeeded({
      profileId: this.props.match.params.id,
      page: 1
    });
  }

  componentDidUpdate() {
    document.body.classList.remove("modal-open");
  }

  render() {
    const { friendsTournamentsList, friendDetails, page } = this.props;    
    if (friendsTournamentsList.isFetching) {
      return (
        <div className="text-center">
          <div className="col-sm-12">
            <img src={loadinggif} alt="" />
          </div>
        </div>
      );
    }    

    if (
      friendsTournamentsList &&
      friendDetails &&      
      friendsTournamentsList.items
    ) {
      return (
        <section className="container-fluid my-tournament-wrapper">
          <div className="row">
            <div className="container">
              <div className="padder-main">
                <div className="row d-flex align-items-center mb-30 ">
                  <div className="col-8 d-flex justify-content-start">
                    <h2 className="bold">
                      {friendDetails.item.name}'s Tournaments
                    </h2>
                  </div>
                </div>                

                <div className="row card-wrapper d-flex justify-content-center justify-content-sm-start">
                  {this.props.friendsTournamentsList.items.length > 0
                    ? this.props.friendsTournamentsList.items.map(
                        (tournament, i) => (
                          <div className="col-auto mb-4" key={i}>
                            <TournamentCardComponent
                              {...tournament}
                              cardClass="card card-my-tournament"
                              brandAvatarClass="profile-pic-56"
                              order={i+1}
                            />
                          </div>
                        )
                      )
                    : ""}
                </div>
                <div className="row mb-30 text-center">
                  <div className="col-sm-12">
                    {this.props.friendsTournamentsList.items.length > 0 ? (
                      !this.props.friendsTournamentsList.isLastPage ? (
                        <button
                          onClick={() => {
                            this.props.invalidateFriendsTournamentsViewAll();
                            this.props.fetchFriendsTournamentsViewAllIfNeeded({
                              profileId: this.props.match.params.id,
                              page: page
                            });
                          }}
                          className="btn btn-pink dark btn-xs"
                        >
                          Load More
                        </button>
                      ) : this.props.friendsTournamentsList.isFetching ? (
                        <img src={loadinggif} alt="" />
                      ) : (
                        ""
                      )
                    ) : this.props.friendsTournamentsList.isFetching ? (
                      <img className="text-center" src={loadinggif} alt="" />
                    ) : (
                      <span>No Tournament Found</span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      );
    } else {
      return <></>;
    }
  }
}

export default ChallengesLiveViewAllComponent;
